var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('span',{staticClass:"copyright"},[_vm._v("© 2021-2024 Clever Home Labs GmbH")]),_c('ul',{staticClass:"footer-links list-inline float-right"},[_c('li',{staticClass:"list-inline-item"},[_c('a',{attrs:{"href":"mailto:thomas@bauche-hamburg.de"}},[_vm._v("Software")])])])])
}]

export { render, staticRenderFns }